/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tickets: NonNullable<unknown>, checkedIn: NonNullable<unknown> }} Ticketssaleshint2Inputs */

const en_ticketssaleshint2 = /** @type {(inputs: Ticketssaleshint2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tickets} tickets · ${i?.checkedIn} checked in`)
};

const de_ticketssaleshint2 = /** @type {(inputs: Ticketssaleshint2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tickets} Tickets · ${i?.checkedIn} eingecheckt`)
};

/**
* | output |
* | --- |
* | "{tickets} tickets · {checkedIn} checked in" |
*
* @param {Ticketssaleshint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketssaleshint2 = /** @type {((inputs: Ticketssaleshint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketssaleshint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketssaleshint2(inputs)
	return de_ticketssaleshint2(inputs)
});
export { ticketssaleshint2 as "ticketsSalesHint" }